import { buildActiveProgressIrlCard } from './standardOverviewIrl';

export const OVERVIEW_MATURITY_PREVIEW_QUERY = 'overviewMaturity';

/** Figma: 6849:6400 (attention) · 6849:7411 (healthy) — preview until overview maturity API exists */
export const MATURITY_FIXTURES = {
    attention: {
        metaItems: ['Full Acquisition', 'Deadline: 2026-09-16 · 17 days remaining', '3 workstreams', '8 team members'],
        sinceLastVisit: {
            newDocuments: 12,
            irlResponses: 4,
            newObservations: 3,
            intelligenceUpdates: 2,
        },
        projectAttention: {
            items: [
                { label: '3 overdue information requests', route: '/irl' },
                { label: '3 tasks overdue', route: '/tasks' },
                { label: '2 high-priority RAID items', route: '/raid' },
                { label: '2 Intelligence Insights require review', route: '/lens-intelligence/insights' },
            ],
        },
        irl: {
            requestCount: 34,
            lastResponseLabel: 'Last response 38 min ago',
            usesDummyData: true,
            overdueCount: 3,
            answered: 21,
            inProgress: 8,
            outstanding: 5,
            progressDisplay: 'legend',
        },
        observations: {
            count: 27,
            headerMeta: 'Latest observation 2h ago',
            subline: '4 added recently',
            preview: ['Legacy infrastructure dependency', 'Limited DR testing evidence'],
        },
        vdr: {
            documentCount: 184,
            folderCount: 13,
            addedRecently: 12,
            latestUploadLabel: 'Latest upload 42 min ago',
            previewFiles: ['security-architecture.pdf', 'application-inventory.xlsx', 'cloud-costs.xlsx'],
        },
        intelligence: {
            ready: true,
            needsReview: true,
            headline: '6 new insights',
            subline: '2 require review',
            meta: 'Last analysed today, 10:42',
            actionLabel: 'Review insights →',
        },
        indexScores: {
            headerMeta: 'Calculated today',
            rows: [
                { label: 'Tech Maturity', value: 72, delta: '+3', deltaTone: 'up', barTone: 'green', barPercent: 72 },
                { label: 'Security', value: 64, delta: '-2', deltaTone: 'down', barTone: 'amber', barPercent: 64 },
                { label: 'Governance', value: 68, delta: '+1', deltaTone: 'up', barTone: 'amber', barPercent: 68 },
                { label: 'Team', value: 71, delta: '—', deltaTone: 'neutral', barTone: 'green', barPercent: 71 },
            ],
            actionLabel: 'View analysis →',
        },
        delivery: {
            tasks: { lines: ['16 open · 3 overdue', '5 due this week'] },
            raid: { lines: ['9 active · 2 high priority'] },
            actionLog: { lines: ['12 open · 3 overdue'] },
        },
        knowledge: {
            lessonsSummary: '8 captured · Latest 2 days ago',
            journalSummary: '14 entries · Latest entry today',
        },
        recentActivity: [
            { time: '10:42', actor: 'Maria Chen', action: 'uploaded security-architecture.pdf', workstream: 'Cybersecurity' },
            { time: '09:58', actor: 'Sarah Ahmed', action: 'answered IRL-24', workstream: 'Information Technology' },
            { time: '09:31', actor: 'James Carter', action: 'created a new observation', workstream: 'Commercial' },
            { time: 'Yesterday', actor: 'RAID-08', action: 'changed to High priority', workstream: 'Delivery' },
            { time: 'Yesterday', actor: 'Priya Nair', action: 'uploaded cloud-costs.xlsx', workstream: 'Finance' },
            { time: '2 days ago', actor: 'Sarah Ahmed', action: 'answered IRL-19, IRL-20, IRL-22', workstream: 'Information Technology' },
        ],
    },
    healthy: {
        metaItems: ['Full Acquisition', 'Deadline: 2026-09-16 · 17 days remaining', '3 workstreams', '8 team members'],
        sinceLastVisit: {
            newDocuments: 5,
            irlResponses: 2,
            newObservations: 1,
            intelligenceUpdates: null,
        },
        projectAttention: null,
        irl: {
            requestCount: 34,
            lastResponseLabel: 'Last response 2h ago',
            overdueCount: 0,
            answered: 30,
            inProgress: 0,
            outstanding: 4,
            progressDisplay: 'summary',
        },
        observations: {
            count: 27,
            headerMeta: 'Latest observation 2h ago',
            subline: '4 added recently',
            preview: ['Legacy infrastructure dependency', 'Limited DR testing evidence'],
        },
        vdr: {
            documentCount: 184,
            folderCount: 13,
            addedRecently: 12,
            latestUploadLabel: 'Latest upload 42 min ago',
            previewFiles: ['security-architecture.pdf', 'application-inventory.xlsx', 'cloud-costs.xlsx'],
        },
        intelligence: {
            ready: true,
            needsReview: false,
            headline: '6 insights',
            subline: 'Up to date',
            meta: 'Last analysed today, 10:42',
            actionLabel: 'Open Intelligence Insights →',
        },
        indexScores: {
            headerMeta: 'Calculated today',
            rows: [
                { label: 'Tech Maturity', value: 72, delta: '+3', deltaTone: 'up', barTone: 'green', barPercent: 72 },
                { label: 'Security', value: 64, delta: '-2', deltaTone: 'down', barTone: 'amber', barPercent: 64 },
                { label: 'Governance', value: 68, delta: '+1', deltaTone: 'up', barTone: 'amber', barPercent: 68 },
                { label: 'Team', value: 71, delta: '—', deltaTone: 'neutral', barTone: 'green', barPercent: 71 },
            ],
            actionLabel: 'View analysis →',
        },
        delivery: {
            tasks: { lines: ['11 open · 0 overdue'] },
            raid: { lines: ['5 active · 0 high priority'] },
            actionLog: { lines: ['8 open · 0 overdue'] },
        },
        knowledge: {
            lessonsSummary: '8 captured · Latest 2 days ago',
            journalSummary: '14 entries · Latest entry today',
        },
        recentActivity: [
            { time: '10:42', actor: 'Maria Chen', action: 'uploaded security-architecture.pdf', workstream: 'Cybersecurity' },
            { time: '09:58', actor: 'Sarah Ahmed', action: 'answered IRL-24', workstream: 'Information Technology' },
            { time: '09:31', actor: 'James Carter', action: 'created a new observation', workstream: 'Commercial' },
            { time: 'Yesterday', actor: 'RAID-08', action: 'changed to High priority', workstream: 'Delivery' },
            { time: 'Yesterday', actor: 'Priya Nair', action: 'uploaded cloud-costs.xlsx', workstream: 'Finance' },
            { time: '2 days ago', actor: 'Sarah Ahmed', action: 'answered IRL-19, IRL-20, IRL-22', workstream: 'Information Technology' },
        ],
    },
};

export function readOverviewMaturityPreview() {
    if (typeof window === 'undefined') return null;
    const value = new URLSearchParams(window.location.search).get(OVERVIEW_MATURITY_PREVIEW_QUERY);
    if (value === 'attention' || value === 'healthy') return value;
    return null;
}

function pickApiMaturity(project) {
    const raw = project?.overview_maturity || project?.overview?.maturity;
    if (raw === 'attention' || raw === 'healthy') return raw;
    return null;
}

export function applyMaturityLayer(model, { previewMode = readOverviewMaturityPreview(), project } = {}) {
    const mode = previewMode || pickApiMaturity(project);
    if (!mode || !MATURITY_FIXTURES[mode]) return model;

    const fx = MATURITY_FIXTURES[mode];
    const irlCard = buildActiveProgressIrlCard({ ...fx.irl, usesDummyData: Boolean(previewMode) });

    return {
        ...model,
        usesMaturityDummyData: Boolean(previewMode),
        maturityMode: mode,
        showExtendedSections: true,
        showSinceLastVisit: true,
        showProjectAttention: mode === 'attention' && Boolean(fx.projectAttention?.items?.length),
        showRecentActivity: true,
        sinceLastVisit: fx.sinceLastVisit,
        projectAttention: fx.projectAttention,
        metaItems: fx.metaItems,
        hasWorkstreams: true,
        vdrConfigured: true,
        vdrPopulated: true,
        documentCount: fx.vdr.documentCount,
        folderCount: fx.vdr.folderCount,
        vdrPreviewFiles: fx.vdr.previewFiles,
        vdrCard: fx.vdr,
        observationsView: fx.observations,
        irlCard,
        intelligence: fx.intelligence,
        indexScoresView: fx.indexScores,
        delivery: fx.delivery,
        knowledge: {
            ...model.knowledge,
            lessonsSummary: fx.knowledge.lessonsSummary,
            journalSummary: fx.knowledge.journalSummary,
        },
        recentActivity: fx.recentActivity,
        highlight: mode === 'attention' ? null : model.highlight,
    };
}
